import axios from 'axios';
import authHeader from './auth-header';
import { API_URL } from './API_URL';

// sample to User service to get data from the API 
class UserService {
  getPublicContent() {
    return axios.get(API_URL + 'value/get');
  }

  getUserBoard() {
      return axios.get(API_URL + 'value/get', { headers: authHeader() });
  }

  getModeratorBoard() {
    return axios.get(API_URL + 'mod', { headers: authHeader() });
  }

  getAdminBoard() {
    return axios.get(API_URL + 'admin', { headers: authHeader() });
  }
}

export default new UserService();
